import React from 'react'
import { useSafeArea } from 'react-native-safe-area-context'

import { useLocalPreference } from '../../../global'
import Astrolabe from '../../components/Astrolabe'
import { useAstrolabe } from '../../context'

const AstrolabeScreen = () => {
  const insets = useSafeArea()
  const { astrolabe, ta } = useAstrolabe()
  const { theme } = useLocalPreference()

  return (
    <Astrolabe
      theme={theme}
      ta={ta}
      astrolabe={astrolabe}
      containerStyle={{ paddingBottom: insets.bottom }}
      version={1}
    />
  )
}
export default AstrolabeScreen
